module.exports = __webpack_public_path__ + "img/hannah-busing-Zyx1bK9mqmA-unsplash.7ebacc3a.jpg";